import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { RetroStatusEnum } from 'src/enumerators';

@Component({
  selector: 'app-path-diagram-slider',
  templateUrl: './path-diagram-slider.component.html',
  styleUrls: ['./path-diagram-slider.component.css']
})

export class PathDiagramSliderComponent implements AfterViewInit, OnChanges {
  parentDiv: HTMLElement;
  showNumber: boolean = false;
  dragPosition = { x: 0, y: 0 };
  colorsMix = [{ color: 'var(--orangemix-light)', value: RetroStatusEnum.Regular }, { color: 'var(--redmix-light)', value: RetroStatusEnum.Bad }];
  @Input() maxValue: number;
  @Input() minValue: number;
  @Input() rangeValueFillList;
  @Input() handleIndex = 0;
  @Input() sliderColorList = [];
  @Output() emitRangeValues = new EventEmitter<number>();

  constructor() { }

  ngAfterViewInit(): void {
    this.listenToHandleChanges();
    this.setFillerPositions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.handleIndex?.currentValue != changes?.handleIndex?.previousValue) {
      this.setElementPosition(this.handleIndex - this.minValue, true);
    }
  }

  listenToHandleChanges() {
    // Retornando parente
    this.parentDiv = document.getElementById('pathLine');

    let docHandle;

    docHandle = document.getElementById('pathHandle');
    // Evento quando solta o mouse
    docHandle.addEventListener('pointerdown', (evt: any) => {
      this.showNumber = true;
      this.setIntervalToHandle();

    });

    this.rangeValueFillList.forEach((element, index) => {
      let docFill = document.getElementById('pathFill-' + index);

      if (this.sliderColorList[index] == this.colorsMix[0].value) docFill.style.backgroundColor = this.colorsMix[0].color;
      else if (this.sliderColorList[index] == this.colorsMix[1].value) docFill.style.backgroundColor = this.colorsMix[1].color;

    });
  }


  // Retorna a posição left relativa ao parente
  returnElementLeftPosition(handleDiv: Element): number {
    return handleDiv.getBoundingClientRect().left - this.parentDiv.getBoundingClientRect().left + 1;
  }

  setIntervalToHandle() {
    const handleInterval = setInterval(() => {
      this.setFillerPositions();
    }, 10);

    addEventListener('mouseup', (evt) => {
      this.showNumber = false;
      clearInterval(handleInterval);
    });
  }

  // Devolve o valor da posição
  setFillerPositions() {
    let docHandle;

    docHandle = document.getElementById('pathHandle');
    const position = this.calculatePositionOutput(docHandle);
    this.handleIndex = position;
    this.emitRangeValues.emit(position);

  }

  calculatePositionOutput(handleElement: HTMLElement) {
    // (100 * left do handle ) / tamanho do pai
    const percentageOfWidth = (100 * (this.returnElementLeftPosition(handleElement))) / this.parentDiv?.offsetWidth;
    return Math.floor((percentageOfWidth / 100) * (this.maxValue - this.minValue));
  }

  // Mexe o handle a partir do clique ou de fatores externos
  setElementPosition(index, change = false) {
    if (index >= 0 && (this.handleIndex != index || change)) {
      this.handleIndex = index;
      const dist = (this.parentDiv?.offsetWidth) * (index / (this.maxValue - this.minValue));
      this.dragPosition = { x: dist, y: 0 };

      setTimeout(() => {
        const handleDiv = document.getElementById('pathHandle');
        this.emitRangeValues.emit(this.calculatePositionOutput(handleDiv));
      }, 30);
    }
  }

}
